<template>
  <div class="typeArea box">
    <div class="top">
        <div class="top-left">
            <div>为了规范化妆品生产经营活动，加强化妆品监督管理，保证化妆品质量安全，保障消费者健康，促进化妆品产业健康发展，化妆品新产品需向药监局提供注册备案检验。贵州健安德拥有专业的技术团队，丰富的行业经验，可同时提供理化、微生物、毒理学、功效、安全评价报告等一站式检测服务，助力化妆品行业健康发展。</div>
            <div @click="$router.push('/aboutUs/contactUs')">
                <img src="@/assets/images/image57.png" alt="">
                <span>联系我们</span>
            </div>
        </div>
        <div class="top-right">
            <defaultImg class="banner" :src="require('@/assets/images/image62.png')"></defaultImg>
        </div>
    </div>
    <div class="bottom">
        <!-- <cusTable :tableData="tableData"></cusTable> -->
        <div class="tableBox"> 
            <cusTable :tableData="tableData1" class="tableItem" rowHeight="37px" periodColumnName="试验周期（天）"></cusTable>
            <cusTable :tableData="tableData2" class="tableItem" rowHeight="72.165px" periodColumnName="试验周期（天）"></cusTable>
        </div>
        <!-- <el-tabs class="tabs" v-model="activeName" @tab-click="{}">
            <el-tab-pane label="微生物检验项目" name="first">
                <tabContent class="mg-top40" :dataList="dataList1"></tabContent>
            </el-tab-pane>
            <el-tab-pane label="理化及风险物质检验项目" name="second">
                <tabContent class="mg-top40" :dataList="dataList2"></tabContent>
            </el-tab-pane>
            <el-tab-pane label="毒理学检验项目" name="third">
                <tabContent class="mg-top40" :dataList="dataList3"></tabContent>
            </el-tab-pane>
        </el-tabs> -->
    </div>
  </div>
</template>

<script>
import tabContent from '@/views/ourService/components/tabContent'
export default {
  name: 'makeUp',
  components:{tabContent},
  data () {
    return {
        activeName: 'first',
        dataList1:[{
            src: require('@/assets/images/image58.png'),
            title: "产品化学试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "产品化学试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "产品化学试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "产品化学试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "产品化学试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "产品化学试验项目"
        }],
        dataList2:[{
            src: require('@/assets/images/image58.png'),
            title: "健康毒理试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "健康毒理试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "健康毒理试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "健康毒理试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "健康毒理试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "健康毒理试验项目"
        }],
        dataList3:[{
            src: require('@/assets/images/image58.png'),
            title: "环境影响试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "环境影响试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "环境影响试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "环境影响试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "环境影响试验项目"
        },{
            src: require('@/assets/images/image58.png'),
            title: "环境影响试验项目"
        }],
        tableData:[
            {
                field: '化妆品单项',
                secondProject: '微生物检测',
                project: '菌落总数、耐热大肠菌群、铜绿假单胞菌、金黄色葡萄球菌、霉菌和酵母菌',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '铅、砷、汞、镉',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: 'pH值',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: 'α-羟基酸（10种）',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '甲醇',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二噁烷',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '甲醛',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '游离甲醛',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '苯基苯并咪唑磺酸等15种组分',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '3-亚苄基樟脑等22种防晒剂',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二氧化钛',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二乙氨羟苯甲酰基苯甲酸己酯',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二乙基己基丁酰胺基三嗪酮',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '亚苄基樟脑磺酸',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '氧化锌',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '吡硫鎓锌等19个组分',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '巯基乙酸',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '对苯二胺等8种组分',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '对苯二胺等32种组分',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二甘醇',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '氢醌',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '苯酚',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '农药残留',
                period: '7',
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '急性皮肤刺激试验',
                period: '25',
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '多次皮肤刺激试验',
                period: '25',
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '急性眼刺激性/腐蚀性试验',
                period: '25',
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '皮肤变态反应试验',
                period: '45',
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '皮肤光毒性试验',
                period: '45',
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '细菌回复突变试验',
                period: '55',
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '体外哺乳动物细胞染色体畸变试验',
                period: '55',
            },
            {
                field: '化妆品品类',
                secondProject: '染发类',
                project: '重金属4项、眼刺激、变态、细菌突变、体外染色体畸变、染发剂、风险物质',
                period: '60',
            },
            {
                field: '化妆品品类',
                secondProject: '染发类',
                project: '基本9项、眼刺激、变态、染发剂、风险物质',
                period: '60',
            },
            {
                field: '化妆品品类',
                secondProject: '烫发类',
                project: '重金属4项、巯基乙酸、pH值、急皮、眼刺激、变态、风险物质',
                period: '60',
            },
            {
                field: '化妆品品类',
                secondProject: '祛斑美白产品',
                project: '基本9项、pH值、多皮、变态、光毒、风险物质',
                period: '60',
            },
            {
                field: '化妆品品类',
                secondProject: '防晒类产品',
                project: '基本9项、防晒剂、多皮、变态、光毒、风险物质',
                period: '60',
            },
            {
                field: '化妆品品类',
                secondProject: '防脱产品',
                project: '微生物、汞、砷、铅、镉、多皮、眼刺激、光毒、变态、细菌回复突变试验、体外哺乳动物细胞染色体畸变试验、风险物质',
                period: '60',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性经口毒性试验',
                period: '35',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性经皮毒性试验',
                period: '35',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性皮肤刺激性试验',
                period: '35',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '多次皮肤刺激性试验',
                period: '35',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性眼刺激性试验',
                period: '35',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '皮肤变态试验',
                period: '65',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '皮肤光毒试验',
                period: '65',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '皮肤光变态反应试验',
                period: '90',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '体内哺乳动物细胞微核试验',
                period: '70',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '鼠伤寒沙门氏菌/回复突变试验',
                period: '70',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '体外染色体畸变试验',
                period: '70',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '体外哺乳动物细胞基因突变试验',
                period: '70',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '亚慢性经口毒性试验',
                period: '180',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '亚慢性经皮毒性试验',
                period: '180',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '致畸试验',
                period: '180',
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性吸入毒性试验',
                period: '90',
            },
        ],
        tableData1:[
            {
                field: '化妆品单项',
                secondProject: '微生物检测',
                project: '菌落总数、耐热大肠菌群、铜绿假单胞菌、金黄色葡萄球菌、霉菌和酵母菌',
                period: '7',
                index: 1
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '铅、砷、汞、镉',
                period: '7',
                index: 2
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: 'pH值',
                period: '7',
                index: 3
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: 'α-羟基酸（10种）',
                period: '7',
                index: 4
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '甲醇',
                period: '7',
                index: 5
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二噁烷',
                period: '7',
                index: 6
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '甲醛',
                period: '7',
                index: 7
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '游离甲醛',
                period: '7',
                index: 8
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '苯基苯并咪唑磺酸等15种组分',
                period: '7',
                index: 9
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '3-亚苄基樟脑等22种防晒剂',
                period: '7',
                index: 10
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二氧化钛',
                period: '7',
                index: 11
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二乙氨羟苯甲酰基苯甲酸己酯',
                period: '7',
                index: 12
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二乙基己基丁酰胺基三嗪酮',
                period: '7',
                index: 13
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '亚苄基樟脑磺酸',
                period: '7',
                index: 14
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '氧化锌',
                period: '7',
                index: 15
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '吡硫鎓锌等19个组分',
                period: '7',
                index: 16
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '巯基乙酸',
                period: '7',
                index: 17
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '对苯二胺等8种组分',
                period: '7',
                index: 18
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '对苯二胺等32种组分',
                period: '7',
                index: 19
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '二甘醇',
                period: '7',
                index: 20
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '氢醌',
                period: '7',
                index: 21
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '苯酚',
                period: '7',
                index: 22
            },
            {
                field: '化妆品单项',
                secondProject: '理化检测',
                project: '农药残留',
                period: '7',
                index: 23
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '急性皮肤刺激试验',
                period: '25',
                index: 24
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '多次皮肤刺激试验',
                period: '25',
                index: 25
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '急性眼刺激性/腐蚀性试验',
                period: '25',
                index: 26
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '皮肤变态反应试验',
                period: '45',
                index: 27
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '皮肤光毒性试验',
                period: '45',
                index: 28
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '细菌回复突变试验',
                period: '55',
                index: 29
            },
            {
                field: '化妆品单项',
                secondProject: '毒理学检测',
                project: '体外哺乳动物细胞染色体畸变试验',
                period: '55',
                index: 30
            },
        ],
        tableData2:[
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性经口毒性试验',
                period: '35',
                index: 31
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性经皮毒性试验',
                period: '35',
                index: 32
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性皮肤刺激性试验',
                period: '35',
                index: 33
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '多次皮肤刺激性试验',
                period: '35',
                index: 34
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性眼刺激性试验',
                period: '35',
                index: 35
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '皮肤变态试验',
                period: '65',
                index: 36
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '皮肤光毒试验',
                period: '65',
                index: 37
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '皮肤光变态反应试验',
                period: '90',
                index: 38
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '体内哺乳动物细胞微核试验',
                period: '70',
                index: 39
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '鼠伤寒沙门氏菌/回复突变试验',
                period: '70',
                index: 40
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '体外染色体畸变试验',
                period: '70',
                index: 41
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '体外哺乳动物细胞基因突变试验',
                period: '70',
                index: 42
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '亚慢性经口毒性试验',
                period: '180',
                index: 43
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '亚慢性经皮毒性试验',
                period: '180',
                index: 44
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '致畸试验',
                period: '180',
                index: 45
            },
            {
                field: '化妆品新原料',
                secondProject: '',
                project: '急性吸入毒性试验',
                period: '90',
                index: 46
            },
        ]
    }
  },
  methods: {},
}
</script> 

<style lang='less' scoped>
    .bottom{
        margin-top: 80px;
    }
</style>
